// extracted by mini-css-extract-plugin
module.exports = {"Aviary":"AviaryVideoBlock_Aviary__3KDFQ","AviaryIframeContainer":"AviaryVideoBlock_AviaryIframeContainer__2NyOj"};